module.exports = __webpack_public_path__ + "static/media/command-icon.8a01173f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/command-icon.svg
// module id = 1295
// module chunks = 29